export const sortingCriteria = [
    {
        _id: "12abde3fgc756f7e8d9r0w13",
        eventKey: "author",
        criteria: "Автор",
        category: "authors",
        filterKey: "name"
    },
    {
        _id: "98hgfe7d3c2b1a0r6e5f4g13",
        eventKey: "genre",
        criteria: "Жанр",
        category: "genres",
        filterKey: "name"
    },
    {
        _id: "45dc3g2f1e6r7e8d9ab0013",
        eventKey: "publicationYear",
        criteria: "Год издания",
        category: "books",
        filterKey: "publicationYear"
    }
];
